module.exports = __webpack_public_path__ + "public/Icons/logout.svg?ce2b5b26";